<template>
  <div>
    <label class="idx-bold">{{
      $t('newAction.stepOne.labels.replicas')
    }}</label>
    <div class="row custom-switch">
      <div class="col-5">
        <input
          type="checkbox"
          class="custom-control-input"
          id="switch-promoters"
          v-model="switchReply.promoters"
        />
        <label class="custom-control-label" for="switch-promoters">{{
          labelPromoters
        }}</label>
      </div>
      <div class="col-7">
        <div style="display: flex;">
          <input
            type="text"
            class="form-control"
            id="input-promoters-id"
            :disabled="!switchReply.promoters"
            v-model="$store.state.actions.action.reply.promoters"
          />
          <button
            v-if="$store.state.actions.action.multiLanguage"
            class="btn btn-gray"
            v-b-modal="`modal-translation-promoters`"
          >
            <i class="far fa-flag"></i>
          </button>
        </div>
        <div class="invalid-feedback">
          {{ $t('newAction.stepOne.feedbackEnterOneQuestion') }}
        </div>
      </div>
    </div>
    <div v-if="action.type !== 'like-dislike'" class="row custom-switch mt-2">
      <div class="col-5">
        <input
          type="checkbox"
          class="custom-control-input"
          id="switch-neutral"
          v-model="switchReply.neutral"
        />
        <label class="custom-control-label" for="switch-neutral">{{
          labelPassives
        }}</label>
      </div>
      <div class="col-7">
        <div style="display: flex;">
          <input
            type="text"
            class="form-control"
            id="input-neutral-id"
            :disabled="!switchReply.neutral"
            v-model="$store.state.actions.action.reply.neutral"
          />
          <button
            v-if="$store.state.actions.action.multiLanguage"
            class="btn btn-gray"
            v-b-modal="`modal-translation-neutral`"
          >
            <i class="far fa-flag"></i>
          </button>
        </div>
        <div class="invalid-feedback">
          {{ $t('newAction.stepOne.feedbackEnterOneQuestion') }}
        </div>
      </div>
    </div>
    <div class="row custom-switch mt-2">
      <div class="col-5">
        <input
          type="checkbox"
          class="custom-control-input"
          id="switch-detractors"
          v-model="switchReply.detractors"
        />
        <label class="custom-control-label" for="switch-detractors">{{
          labelDetractors
        }}</label>
      </div>
      <div class="col-7">
        <div style="display: flex;">
          <input
            type="text"
            class="form-control"
            id="input-detractors-id"
            :disabled="!switchReply.detractors"
            v-model="$store.state.actions.action.reply.detractors"
          />
          <button
            v-if="$store.state.actions.action.multiLanguage"
            class="btn btn-gray"
            v-b-modal="`modal-translation-detractors`"
          >
            <i class="far fa-flag"></i>
          </button>
        </div>
        <div class="invalid-feedback">
          {{ $t('newAction.stepOne.feedbackEnterOneQuestion') }}
        </div>
      </div>
    </div>

    <!-- modal promoters -->
    <b-modal
      id="modal-translation-promoters"
      title="Configurar tradução da pergunta"
      size="lg"
      ok-only
    >
      <p>
        {{ $t('newAction.stepOne.labels.modalTranslationReplies') }}
      </p>

      <div>
        <div class="container">
          <div class="row">
            <div class="col-2" style="padding: 0;">
              <country-flag country="br" size="normal" />
              <label>{{ $t('newAction.stepOne.labels.portuguese') }}</label>
            </div>
            <div class="col col-lg-2">
              <b-form-checkbox
                id="promoter-pt"
                v-model="
                  $store.state.actions.action.reply.languageSupport
                    .promoterCheckedPT
                "
                name="promoter-pt"
              >
                <input
                  class="form-control size-input"
                  v-model="$store.state.actions.action.reply.promoters"
                  style="margin-left: 10px;"
                />
              </b-form-checkbox>
            </div>
          </div>
        </div>

        <div class="container">
          <div class="row">
            <div class="col-2" style="padding: 0;">
              <country-flag country="us" size="normal" />
              <label>{{ $t('newAction.stepOne.labels.english') }}</label>
            </div>
            <div class="col col-lg-2">
              <b-form-checkbox
                id="promoter-en"
                v-model="
                  $store.state.actions.action.reply.languageSupport
                    .promoterCheckedEN
                "
                name="promoter-en"
              >
                <input
                  class="form-control size-input"
                  v-model="
                    $store.state.actions.action.reply.languageSupport
                      .promotersEN
                  "
                  style="margin-left: 10px;"
                />
              </b-form-checkbox>
            </div>
          </div>
        </div>

        <div class="container">
          <div class="row">
            <div class="col-2" style="padding: 0;">
              <country-flag country="es" size="normal" />
              <label>{{ $t('newAction.stepOne.labels.spanish') }}</label>
            </div>
            <div class="col col-lg-2">
              <b-form-checkbox
                id="promoter-es"
                v-model="
                  $store.state.actions.action.reply.languageSupport
                    .promoterCheckedES
                "
                name="promoter-es"
              >
                <input
                  class="form-control size-input"
                  v-model="
                    $store.state.actions.action.reply.languageSupport
                      .promotersES
                  "
                  style="margin-left: 10px;"
                />
              </b-form-checkbox>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- modal neutros -->
    <b-modal
      id="modal-translation-neutral"
      title="Configurar tradução da pergunta"
      size="lg"
      ok-only
      v-if="action.type !== 'like-dislike'"
    >
      <p>
        {{ $t('newAction.stepOne.labels.modalTranslationReplies') }}
      </p>
      <div>
        <div class="container">
          <div class="row">
            <div class="col-2" style="padding: 0;">
              <country-flag country="br" size="normal" />
              <label>{{ $t('newAction.stepOne.labels.portuguese') }}</label>
            </div>
            <div class="col col-lg-2">
              <b-form-checkbox
                id="neutral-pt"
                v-model="
                  $store.state.actions.action.reply.languageSupport
                    .neutralCheckedPT
                "
                name="neutral-pt"
              >
                <input
                  class="form-control size-input"
                  v-model="$store.state.actions.action.reply.neutral"
                  style="margin-left: 10px;"
                />
              </b-form-checkbox>
            </div>
          </div>
        </div>

        <div class="container">
          <div class="row">
            <div class="col-2" style="padding: 0;">
              <country-flag country="us" size="normal" />
              <label>{{ $t('newAction.stepOne.labels.english') }}</label>
            </div>
            <div class="col col-lg-2">
              <b-form-checkbox
                id="neutral-en"
                v-model="
                  $store.state.actions.action.reply.languageSupport
                    .neutralCheckedEN
                "
                name="neutral-en"
              >
                <input
                  class="form-control size-input"
                  v-model="
                    $store.state.actions.action.reply.languageSupport.neutralEN
                  "
                  style="margin-left: 10px;"
                />
              </b-form-checkbox>
            </div>
          </div>
        </div>

        <div class="container">
          <div class="row">
            <div class="col-2" style="padding: 0;">
              <country-flag country="es" size="normal" />
              <label>{{ $t('newAction.stepOne.labels.spanish') }}</label>
            </div>
            <div class="col col-lg-2">
              <b-form-checkbox
                id="neutral-es"
                v-model="
                  $store.state.actions.action.reply.languageSupport
                    .neutralCheckedES
                "
                name="neutral-es"
              >
                <input
                  class="form-control size-input"
                  v-model="
                    $store.state.actions.action.reply.languageSupport.neutralES
                  "
                  style="margin-left: 10px;"
                />
              </b-form-checkbox>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- modal detratores -->
    <b-modal
      id="modal-translation-detractors"
      title="Configurar tradução da pergunta"
      size="lg"
      ok-only
    >
      <p>
        {{ $t('newAction.stepOne.labels.modalTranslationReplies') }}
      </p>
      <div>
        <div class="container">
          <div class="row">
            <div class="col-2" style="padding: 0;">
              <country-flag country="br" size="normal" />
              <label>{{ $t('newAction.stepOne.labels.portuguese') }}</label>
            </div>
            <div class="col col-lg-2">
              <b-form-checkbox
                id="detractor-pt"
                v-model="
                  $store.state.actions.action.reply.languageSupport
                    .detractorCheckedPT
                "
                name="detractor-pt"
              >
                <input
                  class="form-control size-input"
                  v-model="$store.state.actions.action.reply.detractors"
                  style="margin-left: 10px;"
                />
              </b-form-checkbox>
            </div>
          </div>
        </div>

        <div class="container">
          <div class="row">
            <div class="col-2" style="padding: 0;">
              <country-flag country="us" size="normal" />
              <label>{{ $t('newAction.stepOne.labels.english') }}</label>
            </div>
            <div class="col col-lg-2">
              <b-form-checkbox
                id="detractor-en"
                v-model="
                  $store.state.actions.action.reply.languageSupport
                    .detractorCheckedEN
                "
                name="detractor-en"
              >
                <input
                  class="form-control size-input"
                  v-model="
                    $store.state.actions.action.reply.languageSupport
                      .detractorsEN
                  "
                  style="margin-left: 10px;"
                />
              </b-form-checkbox>
            </div>
          </div>
        </div>

        <div class="container">
          <div class="row">
            <div class="col-2" style="padding: 0;">
              <country-flag country="es" size="normal" />
              <label>{{ $t('newAction.stepOne.labels.spanish') }}</label>
            </div>
            <div class="col col-lg-2">
              <b-form-checkbox
                id="detractor-es"
                v-model="
                  $store.state.actions.action.reply.languageSupport
                    .detractorCheckedES
                "
                name="detractor-es"
              >
                <input
                  class="form-control size-input"
                  v-model="
                    $store.state.actions.action.reply.languageSupport
                      .detractorsES
                  "
                  style="margin-left: 10px;"
                />
              </b-form-checkbox>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import CountryFlag from 'vue-country-flag';
import { mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';

export default {
  components: {
    CountryFlag,
  },

  data: () => ({
    labelPromoters: null,
    labelPassives: null,
    labelDetractors: null,
  }),

  computed: {
    ...mapState('settings', ['switchReply']),
    ...mapFields('actions', ['action']),
  },

  watch: {
    'switchReply.promoters': function watchSwitchPromoters(value) {
      if (value === false) {
        this.$store.state.actions.action.reply.promoters = null;
      } else {
        this.$store.state.actions.action.reply.promoters = this.$t(
          'newAction.stepOne.promoters',
        );
      }
    },

    'switchReply.neutral': function watchSwitchNeutral(value) {
      if (value === false) {
        this.$store.state.actions.action.reply.neutral = null;
      } else {
        this.$store.state.actions.action.reply.neutral = this.$t(
          'newAction.stepOne.neutral',
        );
      }
    },

    'switchReply.detractors': function watchSwitchDetractors(value) {
      if (value === false) {
        this.$store.state.actions.action.reply.detractors = null;
      } else {
        this.$store.state.actions.action.reply.detractors = this.$t(
          'newAction.stepOne.detractors',
        );
      }
    },

    'action.type': function watchMyMethodology() {
      this.setLabels();
    },

    '$i18n.locale': function watchLocale() {
      this.setLabels();
    },
  },

  methods: {
    setLabels() {
      // if (this.switchReply.promoters && !this.action._id) {
      //   this.$store.state.actions.action.reply.promoters = this.$t(
      //     'newAction.stepOne.promoters',
      //   );
      // }

      // if (this.switchReply.neutral && !this.action._id) {
      //   this.$store.state.actions.action.reply.neutral = this.$t(
      //     'newAction.stepOne.neutral',
      //   );
      // }

      // if (this.switchReply.detractors && !this.action._id) {
      //   this.$store.state.actions.action.reply.detractors = this.$t(
      //     'newAction.stepOne.detractors',
      //   );
      // }

      if(this.action.type === "like-dislike"){
        this.$store.state.actions.action.reply.neutral = null;
      }

      if (this.action.type === 'nps-0-10' || this.action.type === 'csat-0-10(media)') {
        this.labelPromoters = this.$t(
          'newAction.stepOne.labels.openFieldPromoters9a10',
        );
        this.labelPassives = this.$t(
          'newAction.stepOne.labels.openFieldPassives7e8',
        );
        this.labelDetractors = this.$t(
          'newAction.stepOne.labels.openFieldDetractors0a6',
        );
      } else if (this.action.type === 'ces-1-5') {
        this.labelPromoters = this.$t(
          'newAction.stepOne.labels.openFieldCESPromoters4e5',
        );
        this.labelPassives = this.$t(
          'newAction.stepOne.labels.openFieldCESPassives3',
        );
        this.labelDetractors = this.$t(
          'newAction.stepOne.labels.openFieldCESDetractors1e2',
        );
      } else if (this.action.type === 'nps-1-5') {
        this.labelPromoters = this.$t(
          'newAction.stepOne.labels.openFieldPromoters4e5',
        );
        this.labelPassives = this.$t(
          'newAction.stepOne.labels.openFieldPassives3',
        );
        this.labelDetractors = this.$t(
          'newAction.stepOne.labels.openFieldDetractors1e2',
        );
      } else if (
        this.action.type === 'csat-1-5' ||
        this.action.type === 'csat-1-5(media)'
      ) {
        this.labelPromoters = this.$t(
          'newAction.stepOne.labels.openFieldCSAT4and5',
        );
        this.labelPassives = this.$t('newAction.stepOne.labels.openFieldCSAT3');
        this.labelDetractors = this.$t(
          'newAction.stepOne.labels.openFieldCSAT1and2',
        );
      } else if (this.action.type === '5-stars') {
        this.labelPromoters = this.$t(
          'newAction.stepOne.labels.openField5Stars4and5',
        );
        this.labelPassives = this.$t(
          'newAction.stepOne.labels.openField5Stars3',
        );
        this.labelDetractors = this.$t(
          'newAction.stepOne.labels.openField5Stars1and2',
        );
      } else if (this.action.type === 'like-dislike') {
        this.labelPromoters = this.$t(
          'newAction.stepOne.labels.openFieldLikeDislike1',
        );
        this.labelPassives = '';
        this.labelDetractors = this.$t(
          'newAction.stepOne.labels.openFieldLikeDislike0',
        );
      }
    },
  },

  mounted() {
    this.setLabels();

    this.$store.state.actions.action.reply.languageSupport.promotersEN = this
      .$store.state.actions.action.reply.languageSupport.promotersEN
      ? this.$store.state.actions.action.reply.languageSupport.promotersEN
      : 'What motivated you to give this rating?';

    this.$store.state.actions.action.reply.languageSupport.promotersES = this
      .$store.state.actions.action.reply.languageSupport.promotersES
      ? this.$store.state.actions.action.reply.languageSupport.promotersES
      : '¿Qué te motivó a dar esta calificación?';

    this.$store.state.actions.action.reply.languageSupport.neutralEN = this
      .$store.state.actions.action.reply.languageSupport.neutralEN
      ? this.$store.state.actions.action.reply.languageSupport.neutralEN
      : 'In your opinion, what is missing for us to earn top marks?';

    this.$store.state.actions.action.reply.languageSupport.neutralES = this
      .$store.state.actions.action.reply.languageSupport.neutralES
      ? this.$store.state.actions.action.reply.languageSupport.neutralES
      : 'En su opinión, ¿qué nos falta para obtener las mejores calificaciones?';

    this.$store.state.actions.action.reply.languageSupport.detractorsEN = this
      .$store.state.actions.action.reply.languageSupport.detractorsEN
      ? this.$store.state.actions.action.reply.languageSupport.detractorsEN
      : 'In your opinion, which items should be improved?';

    this.$store.state.actions.action.reply.languageSupport.detractorsES = this
      .$store.state.actions.action.reply.languageSupport.detractorsES
      ? this.$store.state.actions.action.reply.languageSupport.detractorsES
      : 'En su opinión, ¿qué elementos deberían mejorarse?';

    if (!this.action.reply.promoters) {
      this.switchReply.promoters = false;
    }

    if (!this.action.reply.neutral) {
      this.switchReply.neutral = false;
    }

    if (!this.action.reply.detractors) {
      this.switchReply.detractors = false;
    }
  },
};
</script>

<style>
.size-input {
  width: 500px;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/replies/index.vue